<template>
    <div class="conf-preview">
        <header>
            <div class="container pt-5">
                <div class="header-container">
                    <div class="desc-frame content">
                        <h4 class="mb-0">{{ conference.org }}</h4>
                        <h1 class="mt-2">{{ conference.title }}</h1>
                    </div>
                    <div class="logo-frame" v-if="conference.logo">
                        <img :src="conference.logo"/>
                    </div>
                </div>
            </div>
        </header>

        <div class="white-band">
            <div class="container content mt-6">
                <div class="columns">
                    <div class="column is-4">
                        <div class="details-box">
                            <div class="columns">
                                <div class="column is-4 has-text-weight-bold pt-0 pb-1">Dates</div>
                                <div class="column pt-0 pb-1">{{ confDates }}</div>
                            </div>
                            <div class="columns" v-if="conference.is_allow_po || conference.is_allow_cc">
                                <div class="column is-4 has-text-weight-bold pt-0 pb-1">Fees</div>
                                <div class="column pt-0 pb-1">{{fees}}</div>
                            </div>
                            <div class="columns">
                                <div class="column is-4 has-text-weight-bold pt-0 pb-1">Location</div>
                                <div class="column pt-0 pb-1">{{ conference.location }}</div>
                            </div>
                        </div>

                        <b-button v-if="!closed" type="is-primary" expanded size="is-large" class="mt-3 mb-3" @click="register">Register Now<i class="far fa-long-arrow-right ml-3"></i></b-button>
                        <div v-else class="closed-box">
                            <div class="columns is-gapless">
                                <div class="column is-narrow"><i class="far fa-ban mr-4"></i></div>
                                <div class="column">
                                    <div class="has-text-weight-bold">REGISTRATION CLOSED</div>
                                    <div class="meta">Registration Open {{ regDates }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-offset-1">
                        <div v-html="conference.description" class="content"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer has-text-centered">
            <h1>
                <strong>my</strong>247ed.com
            </h1>
        </div>
    </div>
</template>

<script>
    import {client as http} from "../../http_client";
    import {mapGetters} from "vuex";
    import moment from "moment";

    export default {
        name: 'login',
        components: {},
        props: ['code'],
        data: function() {
            return {
                conference: {
                    feeRange: []
                },
                redirectTo: null
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
            fees: function() {
                if (this.conference.feeRange[0] === this.conference.feeRange[1]) {
                    return '$' + this.conference.feeRange[0].toFixed(2);
                } else {
                    return '$' + this.conference.feeRange[0].toFixed(2) + ' - ' + '$' + this.conference.feeRange[1].toFixed(2);
                }
            },
            confDates: function() {
                let s = moment(this.conference.start_at);
                let e = moment(this.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
            regDates: function() {
                let s = moment(this.conference.open_at);
                let e = moment(this.conference.close_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
            closed: function() {
                return (moment().isBefore(this.conference.open_at) || moment().isAfter(this.conference.close_at));
            }
        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('app/conferences/code/' + this.code, {force}).then(response => {
                    this.conference = response.data;
                });
            },
            register: function() {
                if (!localStorage.getItem('redirectTo')) {
                    localStorage.setItem('redirectTo', '/conference-center/register/' + this.conference.id);
                }
                this.$router.push('/?confCode=' + this.conference.code);
            }
        },
        mounted() {
            this.loadConference();
        }
    };
</script>

<style lang="scss" scoped>
    header {
        color: white;
        background: #224C74 linear-gradient(#1e385c, #23507e);

        .header-container {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-content: flex-end;
            align-items: flex-end;
            padding: 1rem;

            .desc-frame {
                color: white !important;

                h1, h4 {
                    color: white !important;
                }

                flex: 5;
                margin-top: 2rem;
                margin-bottom: 2.5rem;

                i {
                    margin-left: 0.7em;
                }
            }

            .logo-frame {
                /*flex: 1;*/
                border: 2px solid #224C74;
                background: white;
                border-radius: 0.3rem;
                padding: 1rem;
                width: 250px;
                height: 245px;

                display: flex;
                align-content: center;
                align-items: center;
                margin-bottom: -2rem;

                img {
                    width: 100%;
                }

                @media (max-width: 768px) {
                    display: none;
                }
            }
        }
    }

    .details-box {
        background-color: #f4f4f4;
        padding: 2rem;
        border-radius: 8px;
    }

    .closed-box {
        margin-top: 3rem;
        background-color: #ffddaa;
        padding: 1rem 2rem;
        border-radius: 8px;

        .meta {
            font-size: 0.85rem;
            color: #796d61;
        }
    }

    .white-band {
        background-color: white;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
        padding-top: 5rem;
        padding-bottom: 10rem;

        @media (max-width: 768px) {
            padding: 1rem 1rem 5rem;
        }
    }

    .footer {
        background: #224C74 linear-gradient(#1e385c, #23507e);
        padding: 5rem 0 5rem;
        color: white !important;

        h1 {
            font-weight: normal;
            font-size: 2rem !important;
            color: #FFF;
            margin-bottom: 1.5rem;
            letter-spacing: -1px;

            strong {
                color: #FFF;
                font-weight: 900;
            }

            @media (max-width: 768px) {
                font-size: 2.2rem !important;
                margin-bottom: 1rem;
            }

            span.beta {
                color: #FFF;
                border: 1px solid #c2c2c2;
                border-radius: 3px;
                padding: 0 4px;
                font-size: 0.6rem;
                margin-left: 0.5rem;
                vertical-align: super;
                font-weight: normal;
                letter-spacing: normal;
            }
        }
    }
</style>
